/**
 * 官网首页独立入口：不加载管理后台的全量依赖(element-plus全量样式/vuex/router等)，加快首屏
 */
import { createApp } from 'vue'
import Website from '@/views/website/index.vue'

import '@/common/css/base.scss'
// 官网仅按需引入用到的element-plus组件样式
import 'element-plus/es/components/button/style/css'
import 'element-plus/es/components/tabs/style/css'
import 'element-plus/es/components/tab-pane/style/css'
import 'element-plus/es/components/dialog/style/css'
import 'element-plus/es/components/row/style/css'

// 兼容旧链接：原单页应用的后台路由(如 /#/login)重定向到 admin.html
const hash = window.location.hash
if (hash.startsWith('#/') && hash !== '#/') {
  window.location.replace('admin.html' + hash)
} else {
  createApp(Website).mount('#app')
}
